import { Capacitor } from "@capacitor/core";
import {
  AdMob,
  BannerAdPluginEvents,
  BannerAdPosition,
  BannerAdSize,
} from "@capacitor-community/admob";

const TEST_BANNER_AD_IDS = {
  android: "ca-app-pub-3940256099942544/6300978111",
  ios: "ca-app-pub-3940256099942544/2934735716",
};

let isInitialized = false;
let isBannerVisible = false;
let listenersAttached = false;

function isAdsDisplayEnabled() {
  const rawValue = process.env.VUE_APP_DISPLAY_ADS;

  if (typeof rawValue !== "string") {
    return false;
  }

  return !["false", "0", "off", "no"].includes(rawValue.trim().toLowerCase());
}

function getPlatform() {
  return Capacitor.getPlatform();
}

function isNativeAdPlatform() {
  return Capacitor.isNativePlatform() && ["android", "ios"].includes(getPlatform());
}

function getBannerAdId() {
  return TEST_BANNER_AD_IDS[getPlatform()] || "";
}

export async function initializeAdMob() {
  if (!isNativeAdPlatform() || isInitialized) {
    return isNativeAdPlatform();
  }

  if (!listenersAttached) {
    AdMob.addListener(BannerAdPluginEvents.Loaded, () => {
      console.log("[AdMob] Banner loaded.");
    });
    AdMob.addListener(BannerAdPluginEvents.FailedToLoad, (error) => {
      console.warn("[AdMob] Banner failed to load.", error);
    });
    listenersAttached = true;
  }

  await AdMob.initialize({
    initializeForTesting: true,
  });

  if (getPlatform() === "ios") {
    try {
      const trackingStatus = await AdMob.trackingAuthorizationStatus();
      if (trackingStatus.status === "notDetermined") {
        await AdMob.requestTrackingAuthorization();
      }
    } catch (error) {
      console.warn("AdMob tracking authorization request failed.", error);
    }
  }

  isInitialized = true;
  return true;
}

export async function showAppBannerAd() {
  try {
    if (!isAdsDisplayEnabled()) {
      return false;
    }

    const canShowAds = await initializeAdMob();
    if (!canShowAds || isBannerVisible) {
      return canShowAds;
    }

    await AdMob.showBanner({
      adId: getBannerAdId(),
      adSize: BannerAdSize.ADAPTIVE_BANNER,
      position: BannerAdPosition.BOTTOM_CENTER,
      margin: 8,
      isTesting: true,
    });

    isBannerVisible = true;
    return true;
  } catch (error) {
    console.warn("AdMob banner failed to show.", error);
    return false;
  }
}

export async function removeAppBannerAd() {
  if (!isInitialized || !isBannerVisible) {
    return;
  }

  try {
    await AdMob.removeBanner();
  } finally {
    isBannerVisible = false;
  }
}
